export default __webpack_public_path__ + "static/media/Hair_18_F_C2.895b6237.svg";